var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.177 3.237a.25.25 0 0 0-.354 0l-7.146 7.146-.646 2.586 2.586-.646 7.146-7.146a.25.25 0 0 0 0-.354l-1.586-1.586zm-1.414-1.06a1.75 1.75 0 0 1 2.475 0l1.585 1.586a1.75 1.75 0 0 1 0 2.474L6.53 13.53a.75.75 0 0 1-.348.198l-4 1a.75.75 0 0 1-.91-.91l1-4a.75.75 0 0 1 .198-.348l7.293-7.293z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export default ForwardRef;